import React, { SyntheticEvent, useContext } from "react";
import { Dropdown } from "@cmsgov/ds-medicare-gov";
import { useTranslate, sendTealiumEvent } from "../../helpers";
import { AppStore } from "../../app/store";
import { ActionType } from "../../@types";
import { defaultState } from "../../app/store/AppStore";

const StarRatingsFilter: React.FunctionComponent<{
  onStarRatingUpdate: (rating: string) => void;
}> = ({ onStarRatingUpdate }) => {
  const {
    state: { searchResultsFilters = defaultState.searchResultsFilters },
    dispatch,
  } = useContext(AppStore.AppContext);
  const { starRatingFilter } = searchResultsFilters;
  const t = useTranslate();
  const starRatingOptions = Array.from(Array(6).keys()).map(val =>
    val.toString()
  );

  return (
    <Dropdown
      onChange={(ev: SyntheticEvent<HTMLSelectElement>): void => {
        // istanbul ignore next: tested elsewhere
        sendTealiumEvent(
          "Find Plans - Available Plans",
          "Star Rating Pull down"
        );
        dispatch({
          type: ActionType.UPDATE_SEARCH_RESULTS_FILTERS,
          payload: {
            ...searchResultsFilters,
            starRatingFilter: ev.currentTarget.value,
          },
        });
        onStarRatingUpdate(ev.currentTarget.value);
      }}
      name="star-rating-filter"
      value={starRatingFilter.toString()}
      label={t("plan_terms.star_rating_filter")}
      id="star-rating-filter"
      options={[
        {
          label: t("plan_terms.select_star_rating"),
          value: "",
        },
        ...starRatingOptions.map(option => ({
          label: `${option} ${
            Number(option) === 5
              ? t("plan_terms.stars")
              : t("plan_terms.stars_and_up")
          }`,
          value: option,
        })),
      ]}
    />
  );
};

export default StarRatingsFilter;
